"use strict";

function _typeof(obj) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (obj) { return typeof obj; } : function (obj) { return obj && "function" == typeof Symbol && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }, _typeof(obj); }

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _react = _interopRequireWildcard(require("react"));

var _propTypes = _interopRequireDefault(require("prop-types"));

var _clsx2 = _interopRequireDefault(require("clsx"));

var _makeStyles = _interopRequireDefault(require("@material-ui/styles/makeStyles"));

var _Typography = _interopRequireDefault(require("@material-ui/core/Typography"));

var _mobileMenuItem = _interopRequireDefault(require("./mobileMenuItem"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _getRequireWildcardCache(nodeInterop) { if (typeof WeakMap !== "function") return null; var cacheBabelInterop = new WeakMap(); var cacheNodeInterop = new WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(nodeInterop) { return nodeInterop ? cacheNodeInterop : cacheBabelInterop; })(nodeInterop); }

function _interopRequireWildcard(obj, nodeInterop) { if (!nodeInterop && obj && obj.__esModule) { return obj; } if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") { return { default: obj }; } var cache = _getRequireWildcardCache(nodeInterop); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (key !== "default" && Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj.default = obj; if (cache) { cache.set(obj, newObj); } return newObj; }

function _slicedToArray(arr, i) { return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i) || _unsupportedIterableToArray(arr, i) || _nonIterableRest(); }

function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }

function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }

function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) { arr2[i] = arr[i]; } return arr2; }

function _iterableToArrayLimit(arr, i) { var _i = arr == null ? null : typeof Symbol !== "undefined" && arr[Symbol.iterator] || arr["@@iterator"]; if (_i == null) return; var _arr = []; var _n = true; var _d = false; var _s, _e; try { for (_i = _i.call(arr); !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"] != null) _i["return"](); } finally { if (_d) throw _e; } } return _arr; }

function _arrayWithHoles(arr) { if (Array.isArray(arr)) return arr; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

var useStyles = (0, _makeStyles.default)(function (theme) {
  var _theme$palette, _theme$palette$primar, _theme$palette$backgr, _theme$palette2, _theme$palette2$backg, _theme$palette2$backg2;

  return {
    title: _defineProperty({
      color: theme === null || theme === void 0 ? void 0 : (_theme$palette = theme.palette) === null || _theme$palette === void 0 ? void 0 : (_theme$palette$primar = _theme$palette.primary) === null || _theme$palette$primar === void 0 ? void 0 : _theme$palette$primar.main,
      marginBottom: theme === null || theme === void 0 ? void 0 : theme.spacing(1),
      textTransform: "uppercase"
    }, theme.breakpoints.up("lg"), {
      display: "none"
    }),
    level2: {
      margin: theme === null || theme === void 0 ? void 0 : theme.spacing(1, 0)
    },
    level3: {
      margin: theme === null || theme === void 0 ? void 0 : theme.spacing(1.5, 0)
    },
    subContainer: {
      background: (_theme$palette$backgr = theme === null || theme === void 0 ? void 0 : (_theme$palette2 = theme.palette) === null || _theme$palette2 === void 0 ? void 0 : (_theme$palette2$backg = _theme$palette2.background) === null || _theme$palette2$backg === void 0 ? void 0 : (_theme$palette2$backg2 = _theme$palette2$backg.menu01) === null || _theme$palette2$backg2 === void 0 ? void 0 : _theme$palette2$backg2.menuMobileBackdropLayer3) !== null && _theme$palette$backgr !== void 0 ? _theme$palette$backgr : "#FFFFFF",
      margin: theme === null || theme === void 0 ? void 0 : theme.spacing(1, 0, 2),
      padding: theme === null || theme === void 0 ? void 0 : theme.spacing(2, 3)
    }
  };
});

var MobileSubContent = function MobileSubContent(_ref) {
  var iconBottom = _ref.iconBottom,
      _ref$level = _ref.level,
      level = _ref$level === void 0 ? 2 : _ref$level,
      submenu = _ref.submenu,
      title = _ref.title;

  var _useState = (0, _react.useState)(null),
      _useState2 = _slicedToArray(_useState, 2),
      showSubmenuID = _useState2[0],
      setShowSubmenuID = _useState2[1];

  var css = useStyles();
  return /*#__PURE__*/_react.default.createElement(_react.default.Fragment, null, /*#__PURE__*/_react.default.createElement(_Typography.default, {
    variant: "h6",
    className: (0, _clsx2.default)("menu-01-mobile-subcontent__title", css.title)
  }, title), submenu === null || submenu === void 0 ? void 0 : submenu.map(function (item) {
    var _clsx, _item$icon;

    return /*#__PURE__*/_react.default.createElement("div", {
      className: (0, _clsx2.default)("menu-01-mobile-menuitem-parent", (_clsx = {}, _defineProperty(_clsx, css.level2, level === 2), _defineProperty(_clsx, css.level3, level === 3), _clsx)),
      key: item.id
    }, /*#__PURE__*/_react.default.createElement(_mobileMenuItem.default, {
      click: function click() {
        setShowSubmenuID(item.id);
      },
      hasChildren: item.items && (item === null || item === void 0 ? void 0 : item.items.length) > 0,
      icon: (_item$icon = item.icon) === null || _item$icon === void 0 ? void 0 : _item$icon.filename,
      iconBottom: iconBottom,
      id: item.id,
      level: level,
      link: item.link,
      selected: item.selected,
      target: item.target,
      title: item.title
    }), showSubmenuID === item.id && /*#__PURE__*/_react.default.createElement("div", {
      className: (0, _clsx2.default)("menu-01-mobile-subcontainer", css.subContainer)
    }, /*#__PURE__*/_react.default.createElement(MobileSubContent, {
      submenu: item.items,
      level: 3
    })));
  }));
};

MobileSubContent.propTypes = {
  iconBottom: _propTypes.default.string,
  level: _propTypes.default.number,
  submenu: _propTypes.default.array.isRequired,
  title: _propTypes.default.string
};
var _default = MobileSubContent;
exports.default = _default;